import React from 'react'
import { useAuth } from '../context/AuthContext/AuthContext'
import { Navigate, Outlet } from 'react-router-dom'

const SigninlySilent = () => {
  const { user } = useAuth()

  return user ? <Navigate to={'/'} replace /> : <Outlet />
}

export default SigninlySilent
